import { t } from "i18next";
import { useAtomValue } from "jotai";

import { fontSizes } from "#app/theme/v1/fontSizes";
import { QuoteRequestActionsMenu } from "#modules/quoteRequests/view/QuoteRequestActionsMenu";
import { quoteRequestAtom } from "#shared/view/components/AppShell/Atoms";
import { QuoteRequestClient } from "#shared/view/components/AppShell/QuoteRequestClient";
import { QuoteRequestReference } from "#shared/view/components/AppShell/QuoteRequestReference";
import { ArchivedChip } from "#shared/view/components/ArchivedChip";
import { Flex } from "#shared/view/components/Flex";
import { Text } from "#shared/view/components/Text";

export const QuoteRequestInfo = () => {
  const quoteRequest = useAtomValue(quoteRequestAtom);

  if (!quoteRequest) {
    return null;
  }

  return (
    <>
      <Flex flex="1" px="lg" py="0" align="center">
        <Flex align={"baseline"}>
          <Text fz={fontSizes.medium}>{t("quoteRequest.quoteRequest")}</Text>
          <QuoteRequestReference />

          <Flex align={"baseline"}>
            <Text fz={fontSizes.tiny}>{t("quoteRequest.for")}</Text>
            <QuoteRequestClient clientId={quoteRequest.clientId} />

            {quoteRequest.isArchived && <ArchivedChip ml="xs" />}
          </Flex>
        </Flex>
        <QuoteRequestActionsMenu />
      </Flex>
    </>
  );
};
